function voicePrompt (text){
    new Audio('http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=4&text=' + encodeURI(text)).play();
}

export {
    voicePrompt
}
